export default [
  {
    descripcion: 'Capital Federal',
    id: '1',
  },
  {
    descripcion: 'Gran Buenos Aires',
    id: '2',
  },
  {
    descripcion: 'Buenos Aires',
    id: '3',
  },
  {
    descripcion: 'Catamarca',
    id: '29',
  },
  {
    descripcion: 'Chaco',
    id: '5',
  },
  {
    descripcion: 'Chubut',
    id: '6',
  },
  {
    descripcion: 'Cordoba',
    id: '7',
  },
  {
    descripcion: 'Corrientes',
    id: '8',
  },
  {
    descripcion: 'Entre Rios',
    id: '9',
  },
  {
    descripcion: 'Formosa',
    id: '32',
  },
  {
    descripcion: 'Jujuy',
    id: '30',
  },
  {
    descripcion: 'La Pampa',
    id: '12',
  },
  {
    descripcion: 'La Rioja',
    id: '31',
  },
  {
    descripcion: 'Mendoza',
    id: '14',
  },
  {
    descripcion: 'Misiones',
    id: '15',
  },
  {
    descripcion: 'Neuquen',
    id: '16',
  },
  {
    descripcion: 'Rio Negro',
    id: '26',
  },
  {
    descripcion: 'Salta',
    id: '18',
  },
  {
    descripcion: 'San Juan',
    id: '19',
  },
  {
    descripcion: 'San Luis',
    id: '20',
  },
  {
    descripcion: 'Santa Cruz',
    id: '33',
  },
  {
    descripcion: 'Santa Fe',
    id: '22',
  },
  {
    descripcion: 'Santiago del Estero',
    id: '28',
  },
  {
    descripcion: 'Tierra del Fuego',
    id: '24',
  },
  {
    descripcion: 'Tucuman',
    id: '25',
  },
].sort((a, b) => ((a.descripcion > b.descripcion) ? 1 : ((b.descripcion > a.descripcion) ? -1 : 0)));
